module.exports = __webpack_public_path__ + "static/media/image-5.4a8cffbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Apteligent/image-5.png
// module id = 255
// module chunks = 0